"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.observableMethods = void 0;
exports.observableMethod = observableMethod;
exports.observableMethods = Symbol('observableMethods');
function observableMethod(_config = {}) {
    return function (target, propertyKey) {
        var _a;
        target[exports.observableMethods] = (_a = target[exports.observableMethods]) !== null && _a !== void 0 ? _a : new Set();
        target[exports.observableMethods].add(propertyKey);
    };
}
// This implementation is based on the JS new decorators proposal, which Typescript supports (and favors) since version 5.0.0.
// use this version instead when other class method decorators in web-ui-framework are updated to the new format and `experimentalDecorators` is disabled in the tsconfig.json
// export function observableMethod(_config: object = {}) {
//   return function (originalMethod: (...args: any) => unknown, context: ClassMethodDecoratorContext): any {
//     context.addInitializer(function (this: any) {
//       this[observableMethods] = this[observableMethods] ?? new Set();
//       this[observableMethods].add(context.name);
//     });
//     return originalMethod;
//   };
// }
//# sourceMappingURL=observableMethod.js.map